import { Link } from 'wouter-preact';
import { RefreshCw } from 'lucide-preact';
import { useQuery } from '@/hooks/useQuery';
import { syncApi } from '@/lib/api/endpoints';
import { cn } from '@/lib/cn';

/**
 * Indicador discreto de sincronización en curso. Sustituye al antiguo
 * `SyncBanner` (franja completa, poco útil): ahora vive como un icono giratorio
 * en el TopBar junto a la campana, sin robar una fila entera. El estado
 * terminal (completada/fallida) sigue cayendo en el centro de notificaciones.
 *
 * Fuente de verdad: `active_session_uuid` de `/api/sync/state`. Comparte la
 * cache `sync.state` con la página de Sincronizaciones (mismo polling).
 */
export function SyncIndicator() {
  const stateQuery = useQuery(
    'sync.state',
    async () => {
      const { data, error } = await syncApi.state();
      if (error) throw new Error('No se pudo cargar el estado de sincronización');
      return data ?? null;
    },
    { refetchInterval: 8000 },
  );

  if (!stateQuery.data.value?.active_session_uuid) return null;

  return (
    <Link
      href="/configuracion/sincronizaciones"
      aria-label="Sincronización en curso — ver progreso"
      title="Sincronización en curso"
      className={cn(
        'text-brand hover:bg-surface-2 relative flex h-9 w-9 items-center justify-center rounded-md transition-colors',
      )}
    >
      <RefreshCw size={16} className="animate-spin" />
    </Link>
  );
}
